import { AxiosResponse } from 'axios';
import HttpStatus from 'model/enums/httpStatus';
import { markError } from 'reducer/application/error/actions';
import { downloadShareholderDocumentError, downloadShareholderDocumentRequest, downloadShareholderDocumentSuccess } from 'reducer/shareholder/download-shareholder-document/actions';
import { DownloadShareholderDocumentActionTypes } from 'reducer/shareholder/download-shareholder-document/types';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import shareholderDocumentsApi from 'services/api/shareholder-documents-api';
import { ErrorUtils } from 'shared/error/error-utils';
import { FileUtils } from 'shared/util/file-utils';

function* handleShareholderDocumentDownloadProfile(action: ReturnType<typeof downloadShareholderDocumentRequest>) {
    try {
        const result: AxiosResponse<Uint8Array> = yield call(shareholderDocumentsApi.downloadDocument, action.payload);
        if (result.status !== HttpStatus.OK) {
            const mapped = ErrorUtils.mapGiroIdhApiError(result);
            yield put(markError(mapped));
            yield put(downloadShareholderDocumentError(mapped));
            return;
        }
        yield put(downloadShareholderDocumentSuccess(result.data));
        FileUtils.downloadDocument(result);
    } catch (error) {
        const mapped = ErrorUtils.mapLocalError(error);
        yield put(markError(mapped));
        yield put(downloadShareholderDocumentError(mapped));
    }
}

function* watchShareholderDocumentDownloadRequest() {
    yield takeEvery(DownloadShareholderDocumentActionTypes.DOWNLOAD_SHAREHOLDER_DOCUMENT_REQUEST, handleShareholderDocumentDownloadProfile);
}

function* downloadShareholderDocumentSagas() {
    yield all([fork(watchShareholderDocumentDownloadRequest)]);
}

export default downloadShareholderDocumentSagas;
